<template>
    <div class="book-later">
        <checker-detail-row>
            <h5>Arriving At</h5>
            <div class="form-groups">
                <div class="form-group">
                    <div class="input-chevron-icon"/>
                    <datepicker
                        id="start_date"
                        :options="trueStartDateConfig(pastBookLimit, onlyBookEarlier, canPastbook.allow)"
                        v-model="start_date"
                        class="datepicker form-control v2-styles dropdown-arrow"
                        name="start_date"
                    />
                </div>
                <div class="form-group">
                    <div class="input-chevron-icon"/>
                    <timepicker
                        id="start_time"
                        :options="trueStartTimeConfig(onlyBookEarlier, canPastbook.allow)"
                        v-model="start_time"
                        class="timepicker form-control v2-styles dropdown-arrow"
                        name="start_time"
                    />
                </div>
            </div>
        </checker-detail-row>
        <checker-detail-row>
            <h5>Departing At</h5>
            <div class="form-groups">
                <div class="form-group">
                    <div class="input-chevron-icon"/>
                    <datepicker
                        id="end_date"
                        :options="endDateConfig"
                        v-model="end_date"
                        class="datepicker form-control v2-styles dropdown-arrow"
                        name="start_date"
                    />
                </div>
                <div class="form-group">
                    <div class="input-chevron-icon"/>
                    <timepicker
                        id="end_time"
                        :options="endTimeConfig"
                        v-model="end_time"
                        class="timepicker form-control v2-styles dropdown-arrow"
                        name="start_time"
                    />
                </div>
            </div>
        </checker-detail-row>
    </div>
</template>

<script>
    import SaneDates from '../../../mixins/SaneDates';
    import Timepicker from '../../../forms/Timepicker';
    import Datepicker from '../../../forms/Datepicker';
    import CheckerDetailRow from '../CheckerDetailRow';
    import BaseDateTimeInput from '../BaseDateTimeInput';
    import storeFormSync from '../../../../store/form-sync';
    import { mapReducers } from '../../../../modules/reducer';
    import moment from 'moment';

    export default {
        name: 'book-earlier',

        components: { CheckerDetailRow, Datepicker, Timepicker },

        mixins: [SaneDates, BaseDateTimeInput],

        props: {
            canPrebook: {
                type: Boolean,
                default() {
                    return false;
                },
            },

            canPastbook: {
                type: Object,
                default() {
                    return {};
                },
            },
        },

        computed: {
            ...storeFormSync([
                'booking.reservation_details.bookings[0].start_date',
                'booking.reservation_details.bookings[0].start_time',
                'booking.reservation_details.bookings[0].end_date',
                'booking.reservation_details.bookings[0].end_time',
                'booking.reservation_details.bookings[0].quote',
            ]),

            ...mapReducers('$store.state.booking.reservation_details', 'booking/updateReservationData', [
                'booking_type',
            ]),

            /**
             *
             * Returns either 24 or 48 hours
             * @return {number}
             */
            pastBookLimit() {
                return this.canPastbook.max_hours_back;
            },

            /**
             * checks if space is only past booking
             * @return {boolean}
             */
            onlyBookEarlier() {
                return this.canPastbook.allow && !this.canPrebook;
            },

            /**
             * depending on the type of booking chosen, assign the correct end date constraints
             *
             * @returns {*|{minDate: string}|{minDate: string, maxDate: string}}
             */
            trueEndDateConfig() {
                if (this.onlyBookEarlier) {
                    return {
                        minDate: this.start_date,
                        maxDate: moment().format('DD-MM-YYYY'),
                    };
                }

                if(this.canPastbook.allow) {
                    return {
                        minDate: this.start_date,
                    };
                }

                return this.startDateConfig;
            },
        },

        watch: {
            start_time(val) {
                if(this.end_date === this.start_date && val >= this.end_time) {
                    this.end_date = this.trueEndDateConfig.minDate;
                    this.end_time = moment(val, 'HH:mm').add(2, 'hours').format('HH:mm');
                }
            },

            start_date(val) {
                if(this.end_date < this.start_date) {
                    this.end_date = val;
                    this.end_time = moment(this.start_time, 'HH:mm').add(2, 'hours').format('HH:mm');
                }
            },

            end_time(val) {
                if(this.end_date === this.start_date && val <= this.start_time) {
                    this.start_date = this.end_date;
                    this.start_time = moment(val, 'HH:mm').subtract(2, 'hours').format('HH:mm');
                }
            },

            end_date(val) {
                if(val <= this.start_date) {
                    this.start_date = val;

                    // if its an earlier date check that the time isn't before it
                    if (this.end_time < this.start_time) {
                        this.start_time = moment(this.end_time, 'HH:mm').subtract(2, 'hours').format('HH:mm');
                    }
                }
            },
        },

        mounted() {
            if (this.onlyBookEarlier) {
                this.start_date = moment(new Date()).format('DD-MM-YYYY');
                this.start_time = moment(new Date()).floor(30, 'minutes').format('HH:mm');
            }
        },
    };
</script>

<style lang="less" scoped>
    .book-later .checker-detail-row.checker-detail-row {
        padding: 0 0 5px;
        border-bottom: 0;
    }
</style>
